module.exports = __webpack_public_path__ + "img/lp-empty.592302cc.png";